import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledMenu = styled.div<{ isAdminMenu?: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: ${theme.token('colors.white')};
  z-index: 999;
  padding: 18px;
  overflow-y: scroll;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    width: 220px;
    left: unset;
    height: auto;
    right: 20px;
    top: 80px;
    border: 1px solid ${theme.token('colors.green.a50')};
    border-radius: ${theme.token('borderRadius.big')};
    overflow-y: hidden;
  }

  @media (min-width: ${theme.token('breakpoints.xl')}) {
    right: calc((100% - 1320px) / 2);
  }

  @media (min-width: ${theme.token('breakpoints.xxl')}) {
    right: calc((100% - ${({ isAdminMenu }) => (isAdminMenu ? '2340px' : '1320px')}) / 2);
  }
`

export const StyledLink = styled.a<{ isDisabled: boolean }>`
  font-size: ${theme.token('fontSizes.md')};
  color: ${({ isDisabled }) => (isDisabled ? theme.token('colors.green.a125') : theme.token('colors.black'))};
  display: block;
  margin-bottom: 20px;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  cursor: pointer;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    font-size: ${theme.token('fontSizes.sm')};
    margin-bottom: 15px;
  }
`
